var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jp-common-layout page" }, [
    _c("div", { staticClass: "jp-common-layout-left" }, [
      _c(
        "div",
        { staticClass: "jp-common-title" },
        [
          _c("el-input", {
            attrs: {
              placeholder: "分类:请输入关键字过滤",
              size: "small",
              clearable: "",
            },
            model: {
              value: _vm.filterText,
              callback: function ($$v) {
                _vm.filterText = $$v
              },
              expression: "filterText",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "jp-common-el-tree-scrollbar el-scrollbar" }, [
        _c("div", { staticClass: "el-scrollbar__wrap" }, [
          _c(
            "div",
            { staticClass: "el-scrollbar__view" },
            [
              _c("el-tree", {
                ref: "categoryTree",
                staticClass: "filter-tree",
                attrs: {
                  data: _vm.categoryTreeData,
                  props: {
                    value: "id", // ID字段名
                    label: "name", // 显示名称
                    children: "children", // 子级字段名
                  },
                  "default-expand-all": "",
                  "filter-node-method": _vm.filterNode,
                  "expand-on-click-node": false,
                  "node-key": "id",
                  "highlight-current": "",
                },
                on: { "node-click": _vm.handleNodeClick },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "jp-common-layout-center jp-flex-main" },
      [
        _c(
          "el-form",
          {
            ref: "searchForm",
            staticClass: "query-form",
            attrs: { size: "small", inline: true, model: _vm.searchForm },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.refreshList()
              },
              submit: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "流程名称", prop: "name" } },
              [
                _c("el-input", {
                  attrs: { size: "small", placeholder: "请输入流程名称" },
                  model: {
                    value: _vm.searchForm.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "name", $$v)
                    },
                    expression: "searchForm.name",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-search",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.refreshList()
                      },
                    },
                  },
                  [_vm._v("查询")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", icon: "el-icon-refresh-right" },
                    on: {
                      click: function ($event) {
                        return _vm.resetSearch()
                      },
                    },
                  },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "bg-white top", staticStyle: { overflow: "auto" } },
          [
            _c(
              "el-row",
              { attrs: { gutter: 12 } },
              _vm._l(_vm.dataList2, function (data) {
                return _c(
                  "el-col",
                  { key: data.id, attrs: { span: 8 } },
                  [
                    _c(
                      "el-card",
                      {
                        staticClass: "box-card",
                        staticStyle: { "margin-bottom": "10px" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "actCard" },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/img/Scheme.png"),
                              },
                            }),
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  color: "#409EFF",
                                  "margin-left": "10px",
                                  width: "150px",
                                  "text-overflow": "ellipsis",
                                  overflow: "hidden",
                                  "white-space": "nowrap",
                                },
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.start(data)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(data.name + " " + data.version))]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }